// extracted by mini-css-extract-plugin
export default {"blogHero":"PostHero_blogHero__+g1qW","backgroundDivider":"PostHero_backgroundDivider__CH83P","heroText":"PostHero_heroText__sBnST"};